import { render, staticRenderFns } from "./MdRecommendation.vue?vue&type=template&id=413d78f4&scoped=true"
import script from "./MdRecommendation.vue?vue&type=script&lang=js"
export * from "./MdRecommendation.vue?vue&type=script&lang=js"
import style0 from "./MdRecommendation.vue?vue&type=style&index=0&id=413d78f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413d78f4",
  null
  
)

export default component.exports